/**
 * Created by justinchasez on 10/31/16.
 */
'use strict';
import {module} from '../app';
import * as _ from 'lodash';
import { constantStrings } from "../constants/constantStrings";

module
  .factory('WorklistFilterViewModel', [
    'WorklistFilterSettings',
    'Worklist',
    'enums',
    'authService',
    'techpadConfig',
    '$rootScope',
    'environmentHelper',
    function (WorklistFilterSettings,
              Worklist,
              enums,
              authService,
              techpadConfig,
              $rootScope,
              environmentHelper) {
      function WorklistFilterViewModel(modalInstance, currentFilters, modalService) {
        let self = this;

        self.techpadConfig = techpadConfig;

        self.constantStrings = constantStrings;

        self.filters = currentFilters;
        self.originalFilters = _.cloneDeep(currentFilters);
        self.modal = modalInstance;
        self.showAppointmentTime = modalService.showAppointmentTime;
        self.showStudyDateOnWorklistPage = modalService.showStudyDateOnWorklistPage;
        self.constantStrings = constantStrings;
        self.isIOSDevice = environmentHelper.isIOSDevice();

        self.examTypes = enums.examTypes;
        self.visitTypes = enums.visitTypes;
        self.allStatusGroups = enums.allStatusGroups;
        self.tags = self.techpadConfig.settings.Tags && self.techpadConfig.settings.Tags.map(tag => tag.Label) || [];

        self.selectQuickFilter = 'Please select at least one quick filter';

        self.NumberOfLastDaysToShowOptions = [
          { value: 2, label: "2" },
          { value: 3, label: "3" },
          { value: 5, label: "5" },
          { value: 7, label: "7" },
          { value: 10, label: "10" },
          { value: 15, label: "15" },
          { value: 20, label: "20" },
          { value: 30, label: "30" },
          { value: 50, label: "50" },
          { value: 100, label: "100" },
          { value: 200, label: "200" },
          { value: 365, label: "365" },
          { value: -1, label: "All" }
        ];

        if(!$rootScope.techpadSettings.GroupExamTypeWorklistFilter){
          Worklist.getExamTypes().then(function(resp){
            self.examTypes = _.map(resp.data, 'Value');
          });
        }        

        Worklist.getLocations()
          .then(function (resp) {
            self.locations = resp.data;
            self.locations.unshift({
              Key: 'All',
              Value: 'All'
            });

          }, function () {
            self.locations = [];
          });

        Worklist.getDisplayStatusesConfigs()
          .then(function (resp) {
            self.statuses = resp.data;
            _.forEach(self.statuses, function (status) {
              status.shouldFilter = self.filters.Statuses[status.Status] === true;
            });
          }, function () {
            self.statuses = [];
          });

        self.getAllowedStatusGroups = function () {
          let userRoles = authService.getRoles();
          const result = _.filter(self.allStatusGroups, function (group) {
            return !group.onlyForRoles || _.find(group.onlyForRoles, function (role) {
                return userRoles.indexOf(role) != -1;
              });
          });
          return result;
        };

        self.statusGroups = self.getAllowedStatusGroups();

        self.statusGroups.forEach(function (group) {
          group.value = self.filters.Statuses[group.key];
        });

        self.onTodayOnlyCheckChanged = function () {
          if (self.filters.ShowTodayExamsOnly) {
            self.filters.ShowNLastDaysExams = false;
          }
        };
        
        self.onShowNLastDaysCheckChanged = function () {
          if (self.filters.ShowNLastDaysExams) {
            self.filters.ShowTodayExamsOnly = false;
          }
        };

        self.toggleVisitTypes = function (visitType) {
          if (visitType == self.constantStrings.allOption) {
            if (self.visitTypeChecked(visitType)) {
              self.filters.VisitTypes = []
            } else {
              self.filters.VisitTypes = _.clone(self.visitTypes.map(type => type.code));
              self.filters.VisitTypes.push(visitType);
            }
            return;
          }
          if (!self.visitTypeChecked(visitType)) {
            self.filters.VisitTypes.push(visitType);
          } else {
            self.filters.VisitTypes = _.without(self.filters.VisitTypes, visitType);
            self.filters.VisitTypes = _.without(self.filters.VisitTypes, self.constantStrings.allOption);
          }
          if (self.filters.VisitTypes.length == self.visitTypes.length) {
            self.filters.VisitTypes.push(self.constantStrings.allOption);
          }
        };

        self.visitTypeChecked = function (visitType) {
          if (visitType == self.constantStrings.allOption) {
            return _.includes(self.filters.VisitTypes, visitType) || self.filters.VisitTypes.length == self.visitTypes.length;
          }
          return _.includes(self.filters.VisitTypes, visitType);
        };

        self.locationsChecked = function (location) {
          return self.filters.Locations[location.Key];
        };

        self.toggleLocations = function (location) { 
          if (location.Key.toUpperCase() == self.constantStrings.allOption) {
              if (self.locationsChecked(location)) {
                self.locations.forEach(loc => self.filters.Locations[loc.Key] = false)
              } else {
                self.locations.forEach(loc => self.filters.Locations[loc.Key] = true)
              }
              return;
            } 
          if (!self.locationsChecked(location)) {
            self.filters.Locations[location.Key] = true;
          } else {
            self.filters.Locations[location.Key] = false;
            self.filters.Locations.All = false;
          }
          var shouldActiveAll = true;

          self.locations.forEach(loc => {
            if(!self.filters.Locations[loc.Key] && loc.Key.toUpperCase() != self.constantStrings.allOption) shouldActiveAll = false;
          })
          if(shouldActiveAll){
            self.locations.forEach(loc => self.filters.Locations[loc.Key] = true)
          }
        };


        self.examTypeChecked = function (examType) {
          return _.includes(self.filters.ExamTypes, examType);
        };

        self.toggleExamType = function (examType) { 
          if (examType == self.constantStrings.allOption) {
              if (self.examTypeChecked(examType)) {
                self.filters.ExamTypes = []
              } else {
                self.filters.ExamTypes =_.clone(self.examTypes);
                self.filters.ExamTypes.push(examType);
              }
              return;
            } 
          if (!self.examTypeChecked(examType)) {
            self.filters.ExamTypes.push(examType);
          } else {
            self.filters.ExamTypes = _.without(self.filters.ExamTypes, examType);
            self.filters.ExamTypes = _.without(self.filters.ExamTypes, self.constantStrings.allOption);
          }
          if (self.filters.ExamTypes.length == self.examTypes.length) {
            self.filters.ExamTypes.push(self.constantStrings.allOption);
          }
        };
        
        self.tagsChecked = function (tag) {
          return _.includes(self.filters.Tags, tag);
        };

        self.sortingOptionsChecked = function (sortOption) {
          return _.includes(self.filters.SortingOptions, sortOption);
        };

        self.toggleSortingOptions = function (sortOption) {
          if(!self.filters.SortingOptions){
            self.filters.SortingOptions = [];
          }

          if (self.constantStrings.DefaultSortOption == sortOption) {
            self.filters.SortingOptions = [];
            self.filters.SortingOptions.push(sortOption);
            return;
          }

          if (self.constantStrings.StudyDateSortOptionAsc == sortOption || self.constantStrings.StudyDateSortOptionDesc == sortOption || self.constantStrings.AppoinmentSortOptionAsc == sortOption || self.constantStrings.AppoinmentSortOptionDesc == sortOption) {
            self.filters.SortingOptions = _.without(self.filters.SortingOptions, self.constantStrings.AppoinmentSortOptionDesc);
            self.filters.SortingOptions = _.without(self.filters.SortingOptions, self.constantStrings.AppoinmentSortOptionAsc);
            self.filters.SortingOptions = _.without(self.filters.SortingOptions, self.constantStrings.StudyDateSortOptionDesc);
            self.filters.SortingOptions = _.without(self.filters.SortingOptions, self.constantStrings.StudyDateSortOptionAsc);
          }

          if (!self.sortingOptionsChecked(sortOption)) {
            self.filters.SortingOptions.push(sortOption);
            self.filters.SortingOptions = _.without(self.filters.SortingOptions, self.constantStrings.DefaultSortOption);
          } else {
            self.filters.SortingOptions = _.without(self.filters.SortingOptions, sortOption);
          }
        };

        self.allStatusGroupsChecked = function () {
          return self.statusGroups.every(group => group.value);
        };

        self.toggleAllStatusGroups = function () {
          const allSelected = self.allStatusGroupsChecked();
          self.statusGroups.forEach(group => {
            group.value = !allSelected;
          });
        };

        self.allStatusesChecked = function () {
          return self.statuses.every(status => status.shouldFilter);
        };

        self.toggleAllStatuses = function () {
          const allSelected = self.allStatusesChecked();
          self.statuses.forEach(status => {
            status.shouldFilter = !allSelected;
          });
        };
        
        
        self.toggleNoTags = function() {
          self.filters.ShowNoTags = !self.filters.ShowNoTags;
          if (!self.filters.ShowNoTags) {
            self.filters.ShowAllTags = false;
          } else {
            self.filters.ShowAllTags = self.filters.Tags.length == self.tags.length;
          }
        };

        self.toggleTags = function (tag) {
          if(!self.filters.Tags){
            self.filters.Tags = [];
          }
          if (tag == self.constantStrings.allOption) {
            if (self.filters.ShowAllTags) {
              self.filters.Tags = []
              self.filters.ShowAllTags = false;
              self.filters.ShowNoTags = false;
            } else {
              self.filters.Tags =_.clone(self.tags);
              self.filters.ShowAllTags = true;
              self.filters.ShowNoTags = true;
            }
            return;
          } 
          if (!self.tagsChecked(tag)) {
            self.filters.Tags.push(tag);
          } else {
            self.filters.Tags = _.without(self.filters.Tags, tag);
            self.filters.ShowAllTags = false;
          }
          self.filters.ShowAllTags = self.filters.Tags.length == self.tags.length && self.filters.ShowNoTags;
        };
        
        self.locationsChecked = function (location) {
          return self.filters.Locations[location.Key];
        };

        self.toggleLocations = function (location) { 
          if (location.Key == self.constantStrings.allOption) {
              if (self.locationsChecked(location)) {
                self.locations.forEach(loc => self.filters.Locations[loc.Key] = false)
              } else {
                self.locations.forEach(loc => self.filters.Locations[loc.Key] = true)
              }
              return;
            } 
          if (!self.locationsChecked(location)) {
            self.filters.Locations[location.Key] = true;
          } else {
            self.filters.Locations[location.Key] = false;
            self.filters.Locations.All = false;
          }
          var shouldActiveAll = true;

          self.locations.forEach(loc => {
            if(!self.filters.Locations[loc.Key] && loc.Key != self.constantStrings.allOption) shouldActiveAll = false;
          })
          if(shouldActiveAll){
            self.locations.forEach(loc => self.filters.Locations[loc.Key] = true)
          }
          self.filters.ShowAllTags = self.filters.Tags.length >= self.tags.length && self.filters.ShowNoTags;
        };


        self.checkQuickFilterValidation = function () {
          let result = true;

          if (!(self.filters && self.filters.ShowAllExams) && !self.filters.ShowMyExamsOnly && !self.filters.ShowTodayExamsOnly) {
            modalService.showAlert(self.selectQuickFilter, function () {
              self.filters.ShowMyExamsOnly = true;
            });
            result = false;
          }

          return result;
        };

        self.saveSettings = function () {
          if (!techpadConfig.settings.IsDashboardMode) {
            self.statusGroups.forEach(function (statusGroup) {
              statusGroup.statuses.forEach(function (status) {
                self.filters.Statuses[status] = statusGroup.value;
              });
            });
          }

          if (techpadConfig.settings.IsDashboardMode) {
            _.forEach(self.statuses, function (status) {
              if (status.shouldFilter) {
                self.filters.Statuses[status.Status] = true;
              } else {
                self.filters.Statuses[status.Status] = false;
              }
            });
          }

          WorklistFilterSettings.saveMySettings(self.filters).then(function () {
            modalInstance.remove();
          }, function (error) {

          });
        };

        self.cancelChanges = function () {
          self.filters = _.cloneDeep(self.originalFilters);
          modalInstance.remove();
        }

        $rootScope.$on('$locationChangeStart', function (event) {
          self.cancelChanges();
        });
      }

      return WorklistFilterViewModel;
    }]);



// WEBPACK FOOTER //
// ./src/scripts/models/WorklistFilterViewModel.js